export default __webpack_public_path__ + "static/media/pw-logo-color.99581764.svg";